import { map } from 'lodash';
import type { IContactCompanyInformation } from './ContactCompanyInformation.interface';
import { epoch, utc } from '../../util/datetime';
import ContactCompanyIndividual from './ContactCompanyIndividual';
import ContactPersonEmploymentCode from './ContactPersonEmploymentCode';
import { ContactCompanyType } from './ContactCompanyType.enum';
import { ContactCompanyTrustStructure } from './ContactCompanyTrustStructure.enum';

export default class ContactCompanyInformation implements IContactCompanyInformation {
  name: string;
  refNumber: string;
  trustRefNumber: string;
  tradingName: string;
  dateOfRegistration: number;
  stateOfRegistration: string;
  numberOfEmployees: number;
  incorporated: number;
  isVatRegistered: boolean;
  vatRegisteredDate: number;
  isActingOnBehalfTrust: boolean;
  trustName: string;
  trustStructure: ContactCompanyTrustStructure;
  typeOfBusinessEntity: ContactCompanyType;
  settlor: string;
  industryCode: ContactPersonEmploymentCode;
  businessType: string;
  individuals: Array<ContactCompanyIndividual>;

  static build = (data: IContactCompanyInformation) => new ContactCompanyInformation(data);
  static blank = () => new ContactCompanyInformation();

  /**
   * Constructor
   * @param {ContactCompanyInformation} data
   */
  constructor(data?: IContactCompanyInformation) {
    this.name = data?.name || '';
    this.refNumber = data?.refNumber || '';
    this.trustRefNumber = data?.trustRefNumber || '';
    this.tradingName = data?.tradingName || '';
    this.dateOfRegistration = data?.dateOfRegistration
      ? epoch(utc(data?.dateOfRegistration))
      : 0;
    this.stateOfRegistration = data?.stateOfRegistration || '';
    this.numberOfEmployees = parseInt(data?.numberOfEmployees || 0, 10);
    this.incorporated = data?.incorporated ? epoch(utc(data?.incorporated)) : 0;
    this.isVatRegistered = data?.isVatRegistered === true;
    this.vatRegisteredDate = data?.vatRegisteredDate ? epoch(utc(data?.vatRegisteredDate)) : 0;
    this.isActingOnBehalfTrust = data?.isActingOnBehalfTrust === true;
    this.trustName = data?.trustName || '';
    this.trustStructure = ContactCompanyTrustStructure.of(
      data?.trustStructure?.name || data?.trustStructure?.toString()
    );
    this.typeOfBusinessEntity = ContactCompanyType.of(
      data?.typeOfBusinessEntity?.name || data?.typeOfBusinessEntity?.toString()
    );
    this.settlor = data?.settlor || '';
    this.industryCode = new ContactPersonEmploymentCode(data?.industryCode);
    this.businessType = data?.businessType || '';
    this.individuals = map(data?.individuals, (obj) => new ContactCompanyIndividual(obj));
  }
}
